export default {
    ENV: "production",
    BASE_URL: "https://vetconsult.wiley.com/",
    CHECKOUT_URL: "https://checkout.wiley.com/en-us/",
    ADD_TO_CART_URL: "https://vetconsult.wiley.com/cart-cta.js",
    ADOBE_ANALYTICS_MODE: "prod",
    ADOBE_ANALYTICS_SCRIPT_URL: "https://assets.adobedtm.com/59640f9fa510/30a2f2139949/launch-1e4f092906d0.min.js",
    LOCALE: "en-us",
    OSANO_SCRIPT_URL:
        "https://cmp.osano.com/AzZdRbSORDOOzF9W/aaa5a811-bd82-475e-ab7e-fd9f772f008d/osano.js",
};